exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--PEu6X5QPOiAPQ-jvFnCHN {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  animation: auto-dialer--PEu6X5QPOiAPQ-jvFnCHN 1.1s infinite linear;\n  border-bottom: 3px solid #e5f4f9;\n  border-left: 3px solid #204661;\n  border-right: 3px solid #e5f4f9;\n  border-top: 3px solid #e5f4f9;\n}\n\n@keyframes auto-dialer--PEu6X5QPOiAPQ-jvFnCHN {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"loader": "auto-dialer--PEu6X5QPOiAPQ-jvFnCHN",
	"loader": "auto-dialer--PEu6X5QPOiAPQ-jvFnCHN"
};